import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgDai = function SvgDai(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#F5AC37",
        d: "M60 0c33.14 0 60 26.865 60 60 0 33.14-26.86 60-60 60-33.135 0-60-26.863-60-60C0 26.865 26.865 0 60 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FEFEFD",
        fillRule: "evenodd",
        d: "M31.426 93.075v.224l-.011.008v.038h26.026c2.945.04 5.88-.194 8.775-.713a40.6 40.6 0 0 0 8.85-2.81c1.228-.569 2.407-1.257 3.595-1.95q.451-.265.906-.526a45 45 0 0 0 4.013-3.224 30 30 0 0 0 7.876-11.475.94.94 0 0 1 1.088-.713h7.087c.564 0 .751-.189.751-.826v-4.539a7.5 7.5 0 0 0 0-1.31c0-.113.029-.226.058-.34.058-.225.116-.45-.058-.675h-5.921c-.716 0-.716-.075-.716-.712a38.3 38.3 0 0 0 0-6.861c-.038-.675.114-.675.637-.675h5.176c.602 0 .826-.151.826-.75v-6.151c-.018-.408-.028-.614-.136-.719-.111-.108-.326-.108-.763-.108h-6.712a.976.976 0 0 1-1.12-.788 30 30 0 0 0-2.93-5.738 36 36 0 0 0-4.012-4.986 33 33 0 0 0-6.6-5.1 36.7 36.7 0 0 0-11.736-4.35 43 43 0 0 0-6.075-.676H32.176c-.75 0-.75.152-.75.751v20.212c0 .713-.151.713-.713.713h-8.062c-.6 0-.6.11-.6.524v6.599c0 .6.187.6.638.6h8.137c.6 0 .6.11.6.56v7.05c0 .638-.19.638-.675.638h-8.7v7.125c0 .6.187.6.638.6h8.137c.6 0 .6.073.6.561v20.512m51.789-45.411a.73.73 0 0 1 0 .523h.18c-.075.224-.45.3-.45.3H39.672c-.713 0-.713-.151-.713-.713v-13.31c0-.49.075-.714.637-.714h20.137a28 28 0 0 1 6.375.675 26.96 26.96 0 0 1 11.25 5.7 9.2 9.2 0 0 1 1.726 1.688A19 19 0 0 1 81.86 45.3c.523.743.974 1.534 1.355 2.363m1.795 16.572H39.861c-.456 0-.681 0-.792-.112-.108-.11-.108-.324-.108-.749v-6.674c0-.527.152-.713.713-.713h45.374c.489 0 .713.186.713.637a43.6 43.6 0 0 1 0 6.974c-.035.637-.264.637-.75.637m-1.795 7.8a8.8 8.8 0 0 0-1.917 0H39.712c-.562 0-.75 0-.75.751v13.014c0 .6 0 .751.75.751h19.2a9.6 9.6 0 0 0 2.735-.186c2.787-.2 5.527-.805 8.14-1.801.951-.33 1.87-.759 2.736-1.275h.262a24.36 24.36 0 0 0 10.462-10.532s.262-.567-.032-.716z",
        clipRule: "evenodd"
    })));
};

export { SvgDai as ReactComponent };
//# sourceMappingURL=DAI.svg.es.js.map
